<template>
    <div class="main">
        <download-Popup />
        <p v-if="isOperamini" class="operamini-tips">
            Untuk memberi Anda pengalaman yang lebih baik, silakan unduh aplikasi profesional kami.
        </p>

        <navVue :subtitleData="getVideoSubTabList" :navSelected="currentNavTag" :pad="true"></navVue>
        <div class="contentWrap" id="contentWrap">
            <!-- 没有数据 -->
            <nodata v-if="noDataMode" :whiteMode="true" />
            <!-- loading -->
            <loading v-if="getToggleLoadingShow" />

            <div class="listwrap" v-if="!noDataMode && !getToggleLoadingShow">
                <div class="list" v-for="(data, index) in getCurrentVideoListData" :key="index">
                    <router-link
                        :to="{ path: `/news/${getUrlTitle(subtitChoose)}/${getUrlTitle(data.title)}/${data.id}?type=video` }">
                        <list-item :listData="data" :firstTit="firstTit" :subtit="subtitChoose" />
                    </router-link>
                </div>
                <loading v-if="getVideoLoadingShow"></loading>

                <div v-if="!getVideoLoadingShow && !getVideoLoadNext" class="noMoreDatas" >
                    Tidak Ada Data Lagi
                </div>
            </div>
        </div>
    </div>
</template>
<script type="text/javascript">
import { mapGetters } from 'vuex'
import navVue from '@/components/navNew.vue'
import nodata from '@/components/nodata.vue'
import carousel from '@/components/carousel.vue'
import transferEntrance from '@/components/transferEntrance.vue'
import listItem from '@/components/listItem.vue'
import loading from '@/components/loading.vue'
import downloadPopup from '@/components/downloadPopup.vue'

export default {
    name: 'video',
    components: {
        listItem,
        carousel,
        transferEntrance,
        navVue,
        loading,
        nodata,
        downloadPopup
    },
    data() {
        return {
            currentNavTag: 'VIDEO',
            scrollLeft: 0, // 记录滚动条长度
            leftToScreen: 0,
            rightToScreen: 0,
            firstTit: 'Video',
            transformY: '',
            noDataMode: false,
            inTimeVideo: null,
            beforeLeaveVideoToNew: null,
            isOperamini: false,
            onScroll: function () { }
        }
    },
    computed: {
        ...mapGetters([
            'getVideoSubTabList',
            'getVideoLoadingShow',
            'getVideoNoDataMode',
            'getCurrentVideoListData',
            'getVideoLoadPrev',
            'getVideoLoadNext',
            'getToggleLoadingShow'
        ]),
        subtitChoose() {
            return this.$store.state.navStore.subtitChoose
        }
    },

    asyncData({ store, route: { params: { subtitle } } }) {
        let allFetch = async () => {
            let menus = await store.dispatch('menusListApi', { subtitle, type: 'VIDEO' })
            const chooseArr = store.getters.getVideoSubTabList.filter(ele => {
                return ele.label === store.state.navStore.subtitChoose
            })
            const urlApi = (chooseArr && chooseArr.length && chooseArr[0].urlApi) || ''
            let videoList = await store.dispatch('videoListApi', { urlApi })
            return Promise.all([
                menus,
                videoList
            ])
        }
        return allFetch()
    },

    beforeRouteEnter: (to, from, next) => {
        if (from.meta.scrollToTop && from.path === '/news') {
            console.log(from.meta.title)
            document.title = from.meta.title
        }
        next(vm => {
            vm.inTimeVideo = new Date()
        })
    },

    beforeRouteLeave: (to, from, next) => {
        next()
    },

    beforeDestroy() {
        window.removeEventListener('scroll', this.onScroll, false)
    },

    mounted() {
        let that = this
        let screenHeight = window.screen.height
        let body = document.body
        this.updateTitle()
        this.onScroll = function () {
            that.stickyFn()
            if (that.getVideoLoadingShow || that.getVideoNoDataMode) return
            let footerOffsetTop = body.getBoundingClientRect().bottom

            if (footerOffsetTop - screenHeight < 6) {
                console.log('刷新～～～')
                that.loadingFn()
            }
        }
        window.addEventListener('scroll', this.onScroll, false)
        let utilObj = require('@/util/util.js')
        utilObj.timeForInOut()
        this.isOperamini = utilObj.checkOperamini()
    },

    methods: {
        stickyFn (ev) {
            window.browers = {}
            let ua = navigator.userAgent.toLowerCase()
            browers.Android = ua.match(/android/)
            browers.iOS = ua.match(/ipad|iphone|ios/)
            if (browers.Android) {
                let topFixedWrap = document.getElementById('topFixedWrap')
                if (!topFixedWrap) {
                    return
                }
                let topFixedWrapHeight = topFixedWrap.offsetHeight // 被定住的位置的高度
                this.scroll = document.body.scrollTop

                let headHeight = 0 // 下载条的高度
                let contentWrap = document.getElementById('contentWrap') // 每个二级导航下的列表内容
                if (this.scroll >= headHeight) {
                    topFixedWrap.className = 'topFixedWrap tab-box-fixed'
                    contentWrap.style.paddingTop = topFixedWrapHeight + 'px'
                } else {
                    topFixedWrap.className = 'topFixedWrap'
                    contentWrap.style.paddingTop = 0 + 'px'
                }
            }
        },
        loadingFn () {
            if (!this.getVideoLoadNext) {
                return
            }
            this.$store.commit('showLoading', { isShow: true })
            this.$store.dispatch('videoListApi', { urlApi: this.getVideoLoadNext, type: 2 }) // 1 初始化 2 滚动载
        },
        updateTitle () {
            if (this.subtitChoose === 'All') {
                document.title = 'All Sepakbola - Live Scores, News, Videos & Highlights'
            } else if (this.subtitChoose === 'Highlights') {
                document.title = 'All Sepakbola - Live Scores, News, Videos & Highlights'
            }
        }
    }
}
</script>
<style lang="less" scoped>
html {
    min-height: 100%;
}

.clearfix:after {
    visibility: hidden;
    display: block;
    font-size: 0;
    content: " ";
    clear: both;
    height: 0;
}

.clearfix {
    *zoom: 1;
}

.clear {
    clear: both;
}

html::-webkit-scrollbar {
    display: none;
}

body::-webkit-scrollbar {
    display: none;
}

.main::-webkit-scrollbar {
    display: none;
}

.loadwrap {
    bottom: 0;
    left: 0;
    width: 100%;
    height: 2rem;
    color: #8c9399;
    background: #eff1f4;
    text-align: center;
    margin: 0 !important;
    line-height: 2rem;
    font-size: 0.68rem;
}

.loadingicon {
    width: 1rem;
    height: 1rem;
    background: url(../assets/home/loading-icon.png) no-repeat;
    background-size: 100% 100%;
    position: absolute;
    top: .5rem;
    left: 0rem;

    animation: rotate linear 1.2s both infinite;
    -webkit-animation: rotate linear 1.2s both infinite;
}

.loading {
    width: 6rem;
    margin: 0 auto;
    height: 2rem;
    line-height: 2rem;
    position: relative;
}

@keyframes rotate {
    0% {
        -webkit-transform: rotate(0deg);
        transform: rotate(0deg);
    }

    50% {
        -webkit-transform: rotate(180deg);
        transform: rotate(180deg);
    }

    100% {
        -webkit-transform: rotate(360deg);
        transform: rotate(360deg);
    }
}

@keyframes rotate {
    0% {
        -webkit-transform: rotate(0deg);
        transform: rotate(0deg);
    }

    50% {
        -webkit-transform: rotate(180deg);
        transform: rotate(180deg);
    }

    100% {
        -webkit-transform: rotate(360deg);
        transform: rotate(360deg);
    }
}

.loadingtext {
    text-indent: 0.4rem;
    display: inline-block;
}

.list a {
    color: #000;
    display: block;
}

.list a:visited {
    color: #888;
}

.fade-enter-active,
.fade-leave-active {
    transition: opacity .3s
}

.fade-enter,
.fade-leave-to

/* .fade-leave-active in <2.1.8 */
    {
    opacity: 0
}

.noMoreDatas {
    font-size: 1rem;
    text-align: center;
    line-height: 1rem;
    padding: 1rem 0;
    color: #b5bcc4;
    display: block;
}

.contentWrap {
    min-height: 65rem;
}

.newsSubTit p,
.newsSubTit span {
    padding: 0 .32rem;
    position: relative;
}

.operamini-tips {
    background: #FFFF00;
    text-align: center;
    font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// AppVideo.vue?3b0ca21c